"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

/**
 * This Context is publicly available, you should implement
 * this if you want to use fields like imagefield, select, color-picker
 */
var PropertyEditorContext = _react["default"].createContext({
  additionalFieldTypes: [],
  skeletonLoader: false,

  /**
   * Use the API gateway for the property editor to fetch the options
   */
  useApiGateway: false
});

var _default = PropertyEditorContext;
exports["default"] = _default;